/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, Input, Output, EventEmitter, OnInit, APP_INITIALIZER, ViewChild } from "@angular/core";
import { ParameterValue } from "../simple-function-action-editor.component";
import { Event } from "app/models/event";
import { PropertyType } from "app/models/property-type";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "app/components/simple-success-error-dialog-box/simple-success-error-dialog-box.component";

@Component({
  selector: 'app-function-parameter-editor-event',
  templateUrl: './event-function-parameter-editor.component.html'
})
export class EventFunctionParameterEditorComponent {

  /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  @Input()
  set event(event: Event) {
    this.mEvent = event;
    this.refreshSelectOptions();
  }

  //Event Trigger for the Rule / Reaction
  mEvent: Event;

  @Input()
  parameterValue: ParameterValue;


  @Output()
  valueChange = new EventEmitter<void>();


  //Boolean used to indicate if the Select Options are ready to be displayed or not
  mRefreshingSelectOptions = true;

  //Available Values for the Parameter Value
  mEventOptions: SelectOption[] = [];
  mSelectOptions: SelectOption[] = [];


  get selectedOption(): SelectOption {
    if (this.parameterValue != null && this.parameterValue.mValue != null && this.parameterValue.mValue.length > 0) {
      return this.mSelectOptions.find(option => option.mValue == this.parameterValue.mValue);
    }
    return null;
  }
  set selectedOption(option: SelectOption) {
    if (this.parameterValue != null) {
      this.parameterValue.mValue = option == null? null : option.mValue;
      this.valueChange.emit();
    }
  }



  constructor(
  ) { }



  async refreshSelectOptions(): Promise<void> {
    this.mRefreshingSelectOptions = true;

    //Refresh the Event Options
    await this.refreshEventOptions();

    //Refresh the Select Options
    const options: SelectOption[] = [];
    options.push(...this.mEventOptions);

    if (this.parameterValue != null && this.parameterValue.mValue != null && this.parameterValue.mValue.length > 0) {
      if (options.find(option => option.mValue == this.parameterValue.mValue) == null) {
        const unknownValueOption = new SelectOption();
        unknownValueOption.mValue = this.parameterValue.mValue;
        unknownValueOption.mDisplay = "UNKNOWN VALUE => " + this.parameterValue.mValue;
        options.push(unknownValueOption);
      }
    }
    
    this.mSelectOptions = options;

    this.mRefreshingSelectOptions = false;
  }

  private async refreshEventOptions(): Promise<void> {
    if (this.mEvent == null || this.mEvent.properties == null) {
      this.mEventOptions = [];
    } else {
      const options: SelectOption[] = [];
      
      const eventOption = new SelectOption();
      eventOption.mValue = "${event}";
      eventOption.mDisplay = "FROM EVENT => TRIGGER";
      options.push(eventOption);

      for (const eventProperty of this.mEvent.properties) {
        if (eventProperty.type == PropertyType.EVENTINST_REFERENCE) {
          const option = new SelectOption();
          option.mValue = "${event." + eventProperty.property + "}";
          option.mDisplay = "FROM EVENT => " + eventProperty.name;
          options.push(option);
        }
      }
      this.mEventOptions = options;
    }
  }

  handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, response.text().toString());
    }
  }

}

class SelectOption {
  mValue: string;
  mDisplay: string;
}
